export const AUTHENTICATE_LOGIN = Symbol('AUTHENTICATE_LOGIN')
export const FULFILL_LOGIN = Symbol('FULFILL_LOGIN')
export const AUTHORIZE_LOGIN = Symbol('AUTHORIZE_LOGIN')
export const LOGOUT = Symbol('LOGOUT')
export const SIGNUP = Symbol('SIGNUP')
export const LOGIN_FAILED = Symbol('LOGIN_FAILED')